import { FormField } from '../form-builder/form-field.model';
import { IViewModel } from '../../interfaces/view-model.interface';

export class MultiDropdownSearchData {
    // Properties.
    public formField: FormField;
    public searchTerm: string;

    // Note:  in the future, additional search options could be added to this class.

    // Constructor.
    public constructor(formField: FormField, searchTerm: string = null) {
        this.formField = formField;
        this.searchTerm = searchTerm;
    }
}

// Define a class used by interface IMultiDropdownDataSource, defined below.
export class MultiDropdownOptionsData implements IViewModel {
    public dropdownOptions: string[];

    // Note:  the following options relate to the type-ahead version of the multi-dropdown form field.
    public isTypeAhead: boolean = false; // Default
    public totalDropdownOptions: number;
    public matchedDropdownOptions: number; // Note:  this number could be larger than the number of values in the 'dropdownOptions'
    //        array if only a limited number of options are meant to be returned to the client.

    public id: number = -1; // Note:  this is required of a model that uses a service that inherits from CollectApiServiceBase,
    //        the easiest/quickest way for us to get started.

    // Note:  the following constructor only takes a 'dropdownOptions' property to make things simpler for the default multi-select dropdown.
    public constructor(dropdownOptions: string[] = null) {
        this.dropdownOptions = dropdownOptions;
    }
}

// IMultiDropdownDataSource -- this interface allows the multi-select dropdown form field component,
//                             MultiDropDownFormFieldComponent, to operate without conditional logic
//                             once the correct data source has been created in method
//                             formInstanceElementReceived.
export interface IMultiDropdownDataSource {
    // getDropdownOptions():  retrieve a list of dropdown options.  The default multi-select dropdown
    //                        will simply parse the form field's 'selectOptions' property and return
    //                        the parsed list.  The type-ahead dropdown will retrieve dropdown options
    //                        from the server.
    //
    //     searchInfo() -- this parameter is required when using an ordinary mult-select dropdown and
    //                     when using a type - ahead dropdown that retrieves a filtered list of dropdown
    //                     options from the server.
    getDropdownOptions(searchInfo: MultiDropdownSearchData): Promise<MultiDropdownOptionsData>;
}
